// Copyright (c) 2020-2023 dātma, inc™
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { ehrCrudUrl } from '../../../settings'
import { showToast } from '../../../utils/utils'

const deleteReportFile = async (itemToDelete) => {
  try {
    const fetchParams = {
      method: 'DELETE',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }

    const url = `${ehrCrudUrl}/report-store/report/${itemToDelete.uuid}`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      showToast('error', `Error with network request: ${response.status}`)
    }

    showToast('success', `${itemToDelete.description} has been deleted`)

    return response
  } catch (e) {
    if (e.name === 'AbortError') {
      console.error('timeout error')
    } else {
      console.log(`error: status=${e.status}`)
    }
    showToast('error', `Error with network request: ${e.status}`)
  }
}

export default deleteReportFile
